import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { ENABLE_REDUX_DEVTOOLS } from "stores/constants";

export interface State {
  isCaseDetailFromValid: boolean;
  setIsCaseDetailFromValid: (value: boolean) => void;
}

export const useCaseStore = create<State>()(
  devtools(
    set => ({
      isCaseDetailFromValid: false,
      setIsCaseDetailFromValid: value =>
        set(
          { isCaseDetailFromValid: value },
          false,
          "CASE_STORE/setIsCaseDetailFromValid"
        )
    }),
    { enabled: ENABLE_REDUX_DEVTOOLS, store: "CaseStore" }
  )
);
